import { render, staticRenderFns } from "./FeaturedTextOne.vue?vue&type=template&id=3e8dad86&"
import script from "./FeaturedTextOne.vue?vue&type=script&lang=js&"
export * from "./FeaturedTextOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports